<template>
    <div class="h-full w-full flex flex-col p-8">
        <form @submit.prevent="submitForm">
            <div v-for="(item, index) in uploadDocuments" :key="index" class="flex flex-col mb-4">
                <div class="flex justify-start items-center">
                    <div class="mr-2">{{ index + 1 }}.</div>
                    <div class="flex-grow mr-4 flex flex-col">
                        <label :for="`document-file-name-${index + 1}`">Document Name</label>
                        <input type="text" :id="`document-file-name-${index + 1}`" v-model.trim="item.document_name.val"
                            placeholder="" />
                    </div>
                    <div class="flex-grow ml-4 flex flex-col">
                        <label :for="`document-file-${index}`">Upload<span class="text-xs text-secondary ml-1">(JPG,
                                JPEG, PNG, PDF, DOC, DOCX, PPT, PPTX max 10MB)</span></label>
                        <div class="flex justify-start items-center">
                            <input :id="`document-file-${index}`" :key="`document-file-${index}`" type="file"
                                @change="handleFileChange"
                                accept="image/*,application/pdf,.doc,.docx,.ppt,.pptx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation" />
                            <div v-if="hasUploadDocuments" class="flex-grow flex justify-end items-center">
                                <button type="button" @click="removeFile(index)">
                                    <icon-close class="h-6 w-6 text-red-600"></icon-close>
                                </button>
                            </div>
                        </div>
                        <transition name="fade" mode="out-in">
                            <p v-if="!item.document.isValid" class="h-4 text-xs text-red-600">
                                {{ item.document.msg }}
                            </p>
                        </transition>
                    </div>
                </div>


            </div>
            <div class="w-full flex justify-center mt-6">
                <div @click.stop="addFile" :class="isFormInvalid ? 'cursor-not-allowed' : 'cursor-pointer'"
                    class="flex items-center bg-white border border-ternary hover:bg-ternary px-4 py-2 rounded-lg cursor-pointer text-ternary hover:text-white">
                    <icon-plus class="w-4 h-4"></icon-plus>
                    <span class="text-xs ml-2">Add more</span>
                </div>
            </div>
            <div class="w-full flex justify-end mt-6">
                <button type="submit" :class="isFormInvalid ? 'cursor-not-allowed' : 'cursor-pointer'"
                    class="flex items-center bg-ternary border border-ternary hover:bg-white px-4 py-2 rounded-lg text-white hover:text-ternary"
                    :disabled="isFormInvalid">Submit</button>
            </div>
        </form>
    </div>
</template>

<script>
import IconPlus from "../../components/icons/IconPlus.vue";
import IconClose from "../../components/icons/IconClose.vue";
export default {
    name: "upload-documents",
    emits: ["document-submit"],
    components: {
        IconPlus,
        IconClose,
    },
    data() {
        return {
            uploadDocuments: [
                {
                    document_name: {
                        val: "",
                        isValid: true,
                        msg: "",
                    },
                    document: {
                        val: null,
                        isValid: true,
                        msg: "",
                    }
                },
            ],
            uploadDocumentIndex: 0,
        };
    },
    computed: {
        hasUploadDocuments() {
            if (this.uploadDocuments.length > 1) {
                return true;
            } else {
                return false;
            }
        },
        isFormInvalid() {
            // Disable the submit button if there are null files
            return this.uploadDocuments.some((file) => (file.document.val === null || file.document_name.val === ""));
        },
    },
    methods: {
        isValidFileType(file) {
            const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
            const validPdfType = 'application/pdf';
            const validDocTypes = [
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            ];
            const validPptTypes = [
                'application/vnd.ms-powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
            ];

            const fileType = file.type.toLowerCase();

            return validImageTypes.includes(fileType) ||
                fileType === validPdfType ||
                validDocTypes.includes(fileType) ||
                validPptTypes.includes(fileType) ||
                file.name.toLowerCase().endsWith('.doc') ||
                file.name.toLowerCase().endsWith('.docx') ||
                file.name.toLowerCase().endsWith('.ppt') ||
                file.name.toLowerCase().endsWith('.pptx');
        },
        handleFileChange(event) {
            const fileIndex = parseInt(event.target.id.split('-').pop());
            const targetIndex = isNaN(fileIndex) ? this.uploadDocumentIndex : fileIndex;

            this.uploadDocuments[targetIndex].document.isValid = true;
            this.uploadDocuments[targetIndex].document.msg = "";
            const file = event.target.files[0];

            if (file) {
                if (!this.isValidFileType(file)) {
                    this.uploadDocuments[targetIndex].document.isValid = false;
                    this.uploadDocuments[targetIndex].document.msg = 'Only JPG, JPEG, PNG, PDF, DOC, DOCX, PPT, and PPTX files are allowed.';
                } else if (file.size > 10 * 1024 * 1024) {
                    this.uploadDocuments[targetIndex].document.isValid = false;
                    this.uploadDocuments[targetIndex].document.msg = 'File size must be less than 10MB.';
                } else {
                    this.uploadDocuments[targetIndex].document.isValid = true;
                    this.uploadDocuments[targetIndex].document.msg = '';
                    this.uploadDocuments[targetIndex].document.val = file;
                }
            }

        },
        addFile() {
            if (this.uploadDocuments.some((file) => (file.document.val === null || file.document_name.val === ""))) {
                console.log('no file');
            } else {
                const obj = {
                    document_name: {
                        val: "",
                        isValid: true,
                        msg: "",
                    },
                    document: {
                        val: null,
                        isValid: true,
                        msg: "",
                    }
                }
                this.uploadDocuments.push(obj);
                this.uploadDocumentIndex += 1;
            }
        },
        removeFile(index) {
            this.uploadDocuments.splice(index, 1);
            this.uploadDocumentIndex -= 1;
        },
        submitForm() {
            let modifiedInputAttachments = this.uploadDocuments.filter(item => item.document.val != null).map(item => {
                return {
                    file_name: item.document_name.val,
                    document: item.document.val
                };
            });
            this.$emit('document-submit', modifiedInputAttachments);
        },
    },
};
</script>

<style lang="scss" scoped>
label {
    @apply mb-1 block text-sm;
}

input[type="text"] {
    @apply block w-full border rounded-lg py-2 px-2;
}

input[type="text"]:focus {
    outline: none;
    border-color: #394867;
    box-shadow: 0 0 0 2px #394867;
}

.invalid label {
    @apply text-red-600;
}

.invalid input {
    border: 1px solid red;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>